"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  rounded: ({
    theme
  }) => ({
    borderRadius: theme.shape.largeComponentRadius
  }),
  outlined: ({
    theme
  }) => ({
    border: `1px solid ${theme.palette.grey[500]}`
  })
};
var _default = exports.default = {
  styleOverrides
};
